export default "__VITE_ASSET__TSJRJHmM__"